'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var core = require('@material-ui/core');
var Validator = require('../../validation/Validator/Validator.js');
var validators = require('../../validation/validators.js');
var styledComponents = require('./styled-components.js');

var InputWithTopLabel = function (props) {
    var title = props.title, value = props.value, reporter = props.reporter, placeholder = props.placeholder, _a = props.fullWidth, fullWidth = _a === void 0 ? true : _a, error = props.error, _b = props.type, type = _b === void 0 ? 'text' : _b, disabled = props.disabled, inputComponent = props.inputComponent, maxLength = props.maxLength, _c = props.className, className = _c === void 0 ? '' : _c, _d = props.readOnly, readOnly = _d === void 0 ? false : _d, _e = props.validators, validators$1 = _e === void 0 ? [] : _e, reportErrors = props.reportErrors, _f = props.isRequired, isRequired = _f === void 0 ? false : _f, _g = props.activateValidation, activateValidation = _g === void 0 ? false : _g, _h = props.onBlur, onBlur = _h === void 0 ? function () { } : _h, _j = props.forceValidation, forceValidation = _j === void 0 ? false : _j, _k = props.suppressErrors, suppressErrors = _k === void 0 ? false : _k, _l = props.preventValueTrim, preventValueTrim = _l === void 0 ? false : _l;
    var _m = React.useState(value !== null && value !== void 0 ? value : ''), param = _m[0], setParam = _m[1];
    var _o = React.useState(false), shouldValidate = _o[0], setShouldValidate = _o[1];
    var allValidators = tslib.__spreadArrays(validators$1);
    if (isRequired)
        allValidators.push(validators.isPresentGenerator());
    React.useEffect(function () {
        setParam(value !== null && value !== void 0 ? value : '');
    }, [value]);
    var handleChange = function (event) {
        var newValue = event.target.value;
        setParam(newValue);
        var reportedValue = preventValueTrim ? newValue : newValue.trim();
        reporter(reportedValue);
    };
    var validationEnabled = isRequired || validators$1.length > 0;
    var handleBlur = function (event) {
        var newValue = event.target.value;
        setParam(preventValueTrim ? newValue : newValue.trim());
        setShouldValidate(validationEnabled);
        onBlur(event);
    };
    return (React__default.createElement(Validator, { validators: allValidators, data: preventValueTrim ? param : param.trim(), shouldValidate: activateValidation || shouldValidate, reportErrors: reportErrors, renderErrors: !suppressErrors, forceValidation: forceValidation, renderChild: function (isError) {
            return (React__default.createElement(styledComponents.Main, { className: className },
                title && typeof title === 'string' && (React__default.createElement(styledComponents.StyledInputLabel, null,
                    React__default.createElement(core.Typography, { variant: 'body2' }, title))),
                title && typeof title !== 'string' && title,
                React__default.createElement(styledComponents.StyledInput, { value: param, fullWidth: fullWidth, onChange: handleChange, onBlur: handleBlur, inputProps: {
                        'data-testid': 'title-input',
                        maxLength: maxLength,
                    }, error: isError || error, placeholder: placeholder || '', type: type, disabled: disabled, readOnly: readOnly, inputComponent: inputComponent })));
        } }));
};

module.exports = InputWithTopLabel;
